import { Component, OnInit, AfterViewInit } from '@angular/core';

// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';

// Others
import 'apexcharts';
import { WHAT } from '../classes';

@Component({
    selector: 'app-graph-user',
    templateUrl: './graph-users.component.html',
    styleUrls: ['./graph-users.component.less']
  })
export class GraphUsersComponent implements OnInit {
    private graph: ApexCharts;
    public totalOverall = {
       overall : "",
       overallpaid : "",
       overallvouchers: ""
    }

    constructor(private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService) {}

    ngOnInit() {
       this.initOverallGraph()
       this.initSubscriptionOverallGraph()
       this.initSubscriptionOverallVoucherGraph()
    }

    private async initOverallGraph() {
      let data;
      try{
       data = await this.admin.GET(WHAT.UsersAnalysis,null,null,null,null,"query=overall");
       this.totalOverall.overall = data.total;
       const accountCategoryData = Object.entries(data.user_account_category);
       const accountTypeData = Object.entries(data.user_account_type);

       const accountTypeChartOptions = {
        chart: {
          type: 'bar'
        },
        series: [{
          name: 'Total',
          data: accountTypeData.map(([type, value]) => ({ x: type, y: value }))
        }],
        xaxis: {
          categories: accountTypeData.map(([type]) => type)
        },
        plotOptions: {
          bar: {
            horizontal: false,
            colors: {
              ranges: [{
                from: 0,
                to: 10000,
                color: '#B90083' // Magenta color
              }]
            }
          }
        },
      };

      const accountCategoryChartOptions = {
        chart: {
          type: 'bar'
        },
        series: [{
          name: 'Total',
          data: accountCategoryData.map(([category, value]) => ({ x: category, y: value }))
        }],
        xaxis: {
          categories: accountCategoryData.map(([category]) => category)
        },
        plotOptions: {
          bar: {
            horizontal: false,
            colors: {
              ranges: [{
                from: 0,
                to: 10000,
                color: '#B90083' // Magenta color
              }]
            }
          }
        },
      };

      this.graph = new ApexCharts(document.querySelector('#overall_account_type'), accountTypeChartOptions);
      this.graph.render();

      this.graph = new ApexCharts(document.querySelector('#overall_account_category'), accountCategoryChartOptions);
      this.graph.render();
       
      }
      catch(e){
        console.log(e);
        this.msg.error(e);
      }
   }
    

    private async initSubscriptionOverallGraph() {
      let data;
      try{
        data = await this.admin.GET(WHAT.UsersAnalysis,null,null,null,null,"query=overall_paid");
        this.totalOverall.overallpaid = data.total;
        const accountCategoryData = Object.entries(data.user_account_category);
        const accountTypeData = Object.entries(data.user_account_type);
 
        const accountTypeChartOptions = {
         chart: {
           type: 'bar'
         },
         series: [{
           name: 'Total',
           data: accountTypeData.map(([type, value]) => ({ x: type, y: value }))
         }],
         xaxis: {
           categories: accountTypeData.map(([type]) => type)
         },
         plotOptions: {
           bar: {
             horizontal: false,
             colors: {
               ranges: [{
                 from: 0,
                 to: 10000,
                 color: '#B90083' // Magenta color
               }]
             }
           }
         },
       };
 
       const accountCategoryChartOptions = {
         chart: {
           type: 'bar'
         },
         series: [{
           name: 'Total',
           data: accountCategoryData.map(([category, value]) => ({ x: category, y: value }))
         }],
         xaxis: {
           categories: accountCategoryData.map(([category]) => category)
         },
         plotOptions: {
           bar: {
             horizontal: false,
             colors: {
               ranges: [{
                 from: 0,
                 to: 10000,
                 color: '#B90083' // Magenta color
               }]
             }
           }
         },
       };
 
       this.graph = new ApexCharts(document.querySelector('#overallpaid_account_type'), accountTypeChartOptions);
       this.graph.render();
 
       this.graph = new ApexCharts(document.querySelector('#overallpaid_account_category'), accountCategoryChartOptions);
       this.graph.render();
      }
      catch(e){
        console.log(e);
        this.msg.error(e);
      }
    }


    private async initSubscriptionOverallVoucherGraph() {
      let data;
      try{
        data = await this.admin.GET(WHAT.UsersAnalysis,null,null,null,null,'query=subscription&account_type=["beginner","developer","expired"]');
       
        this.totalOverall.overallvouchers = data.total;
        const plantypeData = Object.entries(data.plan_type);
        const voucherData = Object.entries(data.voucher);
 
        const planTypeChartOptions = {
         chart: {
           type: 'bar'
         },
         series: [{
           name: 'Total',
           data: plantypeData.map(([type, value]) => ({ x: type, y: value }))
         }],
         xaxis: {
           categories: plantypeData.map(([type]) => type)
         },
         plotOptions: {
           bar: {
             horizontal: true,
             colors: {
               ranges: [{
                 from: 0,
                 to: 10000,
                 color: '#B90083' // Magenta color
               }]
             }
           }
         },
       };
 
       const voucherChartOptions = {
         chart: {
           type: 'bar'
         },
         series: [{
           name: 'Total',
           data: voucherData.map(([status, value]) => ({ x: status, y: value }))
         }],
         xaxis: {
           categories: voucherData.map(([status]) => status)
         },
         plotOptions: {
           bar: {
             horizontal: false,
             colors: {
               ranges: [{
                 from: 0,
                 to: 10000,
                 color: '#B90083' // Magenta color
               }]
             }
           }
         },
       };
 
       this.graph = new ApexCharts(document.querySelector('#plan_type'), planTypeChartOptions);
       this.graph.render();
 
       this.graph = new ApexCharts(document.querySelector('#voucher'), voucherChartOptions);
       this.graph.render();
      }
      catch(e){
        console.log(e);
        this.msg.error(e);
      }
    }


}


